// extracted by mini-css-extract-plugin
export default {"container":"PageContainer_container__6k6w3"};